import { Log } from '../../shared/log';
const log = Log.getLogger('TemplateDrivenWidgetComponent');

import { Component, OnInit, ElementRef, ApplicationRef } from '@angular/core';
import * as _ from 'underscore';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { SubmitProxyService } from './services/submit-proxy.service';
import { WidgetMachineService } from './services/widget-machine.service';
import { BroadcastService } from '../../services/broadcast/broadcast.service';
import { AuthHttpError } from 'angular2-jwt';
import { PageService } from './page.service';
import { WidgetPreferencesService } from './services/widget-preferences.service';
import { PreFillService } from './pre-fill.service';
import { WidgetListsByPreferenceService } from '../widgetDisplayQueries/widget-lists-by-preference.service';

@Component({
  selector: 'app-template-driven-widget',
  templateUrl: './template-driven-widget.component.html',
})
export class TemplateDrivenWidgetComponent implements OnInit {

  widget;

  message: any;

  currentPage: string;
  currentPageId: string;

  pageHistory: Array<any> = [];

  widgetValues = new Map();

  pendingPage = false;

  workflow: Array<any> = [];

  displayWidget = true;

  widgetPreferences = {};

  constructor(private analyticsService: AnalyticsService,
              private submitService: SubmitProxyService,
              private service: WidgetMachineService,
              private element: ElementRef,
              private _app: ApplicationRef,
              private broadcastService: BroadcastService,
              private pageService: PageService,
              private widgetPreference: WidgetPreferencesService,
              private preFillService: PreFillService,
              private widgetListService: WidgetListsByPreferenceService) {}

  setCurrentPage(newPage) {
    this.currentPage = _.values(newPage)[0];
    this.currentPageId = _.keys(newPage)[0];
    this.afterPageChange();
  }

  ngOnInit() {
    this.workflow = this.widget['workflow'];
    this.setCurrentPage(this.workflow[0]);
    this.analyticsService.send('Show', this.googleAnalyticsName(), this.currentPage);
    this.widgetPreferences = this.widgetPreference.getWidgetPreferencesByName(this.widget.widgetName);
    this.widgetPreference.subscribeSubject(this.widget.widgetName).subscribe((results) => {
      this.widgetPreferences = results;
    });

    this.preFillService.preFill(this.widget.pages, this.widgetValues);
  }

  shouldSubmitData() {
    if (this.getPageInformation(this.currentPage) && this.getPageInformation(this.currentPage)['call_on_submit']) {
      this.submitData();
    } else {
      this.nextBtn()
    }
  }

  submitData() {
    this.pendingPage = true;

    const finished = this.submitService.submit(this.widget.widgetName, this.widgetValues);
    this.sendGoogleAnalyticsData('Submit');

    finished.then(() => {
      this.sendGoogleAnalyticsData('Submit Success');
      this.nextBtn();
      this.pendingPage = false;
      this.autofocus();
    }).catch((error) => {
      this.errorHandler(error);
      this.sendGoogleAnalyticsData('Submit Api Error');
      this.pendingPage = false;
      this.autofocus();
    });
  }

  goToPage(nextPage) {
    const hasPage = this.pageService.getPageByName(nextPage, this.workflow);
    this.widgetPreference.updateDataWidgetPreference(this.widget.widgetName, true, this.widget.id);

    if (hasPage) {
      this.pageHistory.push({[this.currentPageId] : this.currentPage});
      this.setCurrentPage(hasPage);
      this.autofocus();

      this.isStepOrEnter();
    }
  }

  getNextPage(currentPage, workflow): string {
    return this.pageService.getNextPage(currentPage, workflow);
  }

  storeWidgetValues(formValues) {
    _.each(formValues, (value) => {
      this.widgetValues.set(_.keys(value)[0], _.values(value)[0]);
    });
  }

  getPageInformation(pageName) {
    return _.find(this.widget.pages, (page) => {
      return page['page_name'] === pageName;
    });
  }

  cancelBtn() {
    this.resetWidget();
    this.sendGoogleAnalyticsData('Exit');
    this.setCurrentPage(this.workflow[0]);
    this.autofocus();
  }

  resetWidget() {
    this.widgetValues.clear();
    this.preFillService.preFill(this.widget.pages, this.widgetValues);
    this.pageHistory = [];
    this.clearWidgetMessages();
    this.setCurrentPage(this.workflow[0]);
    this.autofocus();
  }

  backBtn() {
    this.setCurrentPage(this.pageHistory.pop());
    this.sendGoogleAnalyticsData('Step');
    this.autofocus();
    this.clearWidgetMessages();
  }

  nextBtn() {
    this.pageHistory.push({[this.currentPageId] : this.currentPage});
    const newPage = this.getNextPage(this.currentPageId, this.workflow);
    this.widgetPreference.updateDataWidgetPreference(this.widget.widgetName, true, this.widget.id);
    if (newPage === this.workflow[0]) {
      this.resetWidget();
    } else {
      this.nextPage(newPage);
    }
  }

  nextPage(newPage) {
    this.clearWidgetMessages();
    this.setCurrentPage(newPage);
    this.isStepOrEnter();
    this.autofocus();
  }

  nextPageNoHistory() {
    this.setCurrentPage(this.getNextPage(this.currentPageId, this.workflow));
  }

  sendGoogleAnalyticsData(action) {
    this.analyticsService.send(action, this.googleAnalyticsName(), this.currentPage);
  }

  googleAnalyticsName() {
    if (this.widget.pages.length === 1) {
      return 'ng My Account Promo Widget - ' + this.widget.accessibility_name;
    }
    return 'ng My Account Multistep ' + this.widget.accessibility_name;
  }

  afterPageChange() {
    if (this.getPageInformation(this.currentPage) && this.getPageInformation(this.currentPage)['on_init']) {
      this.service[this.getPageInformation(this.currentPage)['on_init']]().then((response) => {
        this.message = { 'message': this.getPageInformation(this.currentPage)['on_init_success_message'], 'type': 'success'};
      }).catch((error) => {
        this.message = { 'message': this.getPageInformation(this.currentPage)['on_init_error_message'], 'type': 'error'};
      });
    }
  }

  isStepOrEnter() {
    if (this.pageHistory.length <= 1) {
      this.sendGoogleAnalyticsData('Enter');
    } else {
      this.sendGoogleAnalyticsData('Step');
    }
  }

  autofocus() {
    // auto focus first input for accessibility
    this._app.tick();
    const focusableElements = (<any>this.element.nativeElement).querySelector('input, select, textarea, button');
    if (focusableElements) {
      focusableElements.focus();
    }
  }

  errorHandler(error) {
    if (error instanceof AuthHttpError) {
      this.authError(error);
    }
    if (this.widget[error.status]) {
      this.message = { 'message': this.widget[error.status], 'type': 'error'};
    } else {
      this.message = { 'message': this.widget['500'], 'type': 'error'};
    }
  }

  authError(error) {
    const errorMessage = {
      message: 'Session Error',
      payload: error
    };
    this.broadcastService.broadcast(errorMessage);
  }

  widgetInitialisationError() {
    const errorMessage = {
      message : 'Widget Fail',
      payload: {
        name: this.widget.accessibility_name
      }
    };
    this.broadcastService.broadcast(errorMessage);
    this.displayWidget = false;
  }

  clearWidgetMessages() {
    this.message = {};
  }

  favourite() {
    this.widgetPreference.updateFavouriteWidgetPreference(this.widget.widgetName, true, this.widget.id);
    this.widgetListService.addToFavourites(this.widget.widgetName);
  }

  archive() {
    this.widgetPreference.updateArchiveWidgetPreference(this.widget.widgetName, true, this.widget.id);
    this.widgetListService.addToArchived(this.widget.widgetName);
  }

  unfavourite() {
    this.widgetPreference.updateFavouriteWidgetPreference(this.widget.widgetName, false, this.widget.id);
    this.widgetListService.removeFromFavourites(this.widget.widgetName);

  }

  unarchive() {
    this.widgetPreference.updateArchiveWidgetPreference(this.widget.widgetName, false, this.widget.id);
    this.widgetListService.removeFromArchived(this.widget.widgetName);

  }
}



// WEBPACK FOOTER //
// ./app/widgets/templateDrivenWidget/template-driven-widget.component.ts